// extracted by mini-css-extract-plugin
export var label = "_b2-5";
export var slideContainer = "_b2-0";
export var slider = "_b2-1";
export var sliderLg = "_b2-4";
export var sliderMd = "_b2-3";
export var sliderSm = "_b2-2";